import { inject, Injectable } from '@angular/core';
import { SmartCaptchaService } from '@core/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccMailSubscriptionService, PromoActions } from '@promo/data-access';
import { User, UserProfileFacade } from '@spartacus/user';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class EmailSubscriptionEffects {
  private actions$ = inject(Actions);
  private smartCaptchaService = inject(SmartCaptchaService);
  private mailSubscription = inject(OccMailSubscriptionService);
  private userProfile = inject(UserProfileFacade);

  subscribeEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PromoActions.SUBSCRIBE_EMAIL),
      switchMap((action: PromoActions.SubscribeEmail) =>
        this.smartCaptchaService.execute().pipe(
          switchMap((captchaToken) => {
            const request$ = action.isLoggedIn
              ? this.userProfile.update({
                  email: action.email,
                  marketingEmailsConsent: true,
                } as Partial<User>)
              : this.mailSubscription.subscribe(action.email, captchaToken);

            return request$.pipe(
              map(() => new PromoActions.SubscribeEmailSuccess(true)),
              catchError((err) => of(new PromoActions.SubscribeEmailFailure(err))),
            );
          }),
          catchError((err) => of(new PromoActions.SubscribeEmailFailure(err))),
        ),
      ),
    ),
  );
}
